import React, { Fragment, memo, useEffect, useState } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import axios from 'axios';
import InfiniteScroll from "react-infinite-scroller";

import { postHasMoreState } from '../../../store/postHasMoreState';
import { postState } from '../../../store/postState';
import { infinitScrollPage } from '../../../store/infinitScrollPage';

export const PostArchiveInfinitScroll = memo((props) => {
  const { init_hospital } = props;
  const [postData, setPostData] = useRecoilState(postState);
  const [hasMoreData, setHasMoreData] = useRecoilState(postHasMoreState);
  const [pageData, setPageData] = useRecoilState(infinitScrollPage);

  const getHospitalPost = async () => {
    // axios csrfToken
    const csrfToken = document.querySelector('[name=csrf-token]').content
    axios.defaults.headers.common['X-CSRF-Token'] = csrfToken

    const res = await axios.get(`/agent/hospitals/${init_hospital.id}/hospital_posts?page=${pageData + 1}`)
                .then(resp => {
                  console.log("get hospital_posts success");
                  console.log(resp.data);
                  if (resp.data.length < 1) {
                    console.log("取得データがありません");
                    setHasMoreData(false);
                    return;
                  }
                  setPostData([...postData, ...resp.data]);
                  setPageData(pageData + 1);
                })
                .catch(e => {
                  console.log("hospital_posts error");
                  console.log(e.response);
                  setHasMoreData(false);
                });
    return res;
  }

  //項目を読み込むときのコールバック
  const loadMore = () => {
    console.log("PostArchiveInfinitScroll loadMore pageData!");
    console.log(pageData);

    setTimeout(() => {
      getHospitalPost();
    }, 500);
  }

  // CSSスタイル
  const ulCss = {
    width: "100%",
    listStyle: "none",
    margin: "0",
    padding: "0",
  };
  const liCss = {
    width: "100%",
    fontSize: "14px",
    backgroundColor: "#fff",
    borderBottom: "1px solid #ccc",
    padding: "10px 20px",
  };
  const createdDtCss = {
    display: "inline-block",
    color: "#999",
  }
  const nameCss = {
    display: "inline-block",
    fontWeight: "bold",
    marginLeft: "7px",
  }
  const loaderCss = {
    width: "100%",
    textAlign: "center",
    padding: "5px 0",
    color: "#999"
  }

  //スクロール中の投稿
  const lists = (
    <ul style={ulCss}>
      {postData.map((post, idx) => 
        <li key={idx} style={liCss}>
          <div>
            <span style={createdDtCss}>{post.created_at}</span>
            <span style={nameCss}>{post.staff_name}</span> 
          </div>
          {post.content}
        </li>
      )}
    </ul>
  );

  //ロード中に表示する項目
  const loader =<div key={0} style={loaderCss}>Loading ...</div>;

  console.log("PostArchiveInfinitScroll hasMoreData Check!");
  console.log(hasMoreData);
  return (
    <>
      <InfiniteScroll
        pageStart={pageData}
        loadMore={loadMore}
        hasMore={hasMoreData}
        loader={loader}
        useWindow={false}>
          {lists}
      </InfiniteScroll>
    </>
  );
});